import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16} from '@homeaway/svg-defs';
import CollapseBase from '../CollapseBase/CollapseBase';
import './Divider.less';

class Divider extends Component {
    static propTypes = {
        /** id tag for Component. Required for assistive devices (a11y) */
        id: PropTypes.string.isRequired,
        /** Heading for the Divider Panel. A simple string or function that returns the content to render. */
        heading: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
        /** Optional event handler to trigger when the component expands or collapses.  Passes the isExpanded boolean as a parameter. */
        onExpandedChange: PropTypes.func,
        /** Should the Divder be opened by default.  For use if being used as a controlled component. */
        expanded: PropTypes.bool
    }

    static defaultProps = {
        expanded: false,
        onExpandedChange: () => {}
    }

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);

        this.state = {
            isExpanded: this.props.expanded
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.expanded !== nextProps.expanded) {
            this.setState({
                isExpanded: nextProps.expanded
            });
        }
    }

    handleClick(e) {
        e.preventDefault();
        const isExpanded = !this.state.isExpanded;

        this.setState({isExpanded});

        this.props.onExpandedChange(isExpanded);
    }

    render() {
        const {id, heading, children, className, onExpandedChange, expanded, ...rest} = this.props; // eslint-disable-line no-unused-vars
        const {isExpanded} = this.state;
        const divClassName = classNames('Divider', className);
        const svgClassName = classNames('Divider__SVGIcon', {
            'Divider__SVGIcon--collapsed': !isExpanded
        });
        const dividerId = `${id}_button`;

        return (
            <div
                className={divClassName}
                {...rest}
            >
                <div className="Divider__heading text-muted" role="heading" {...rest}>
                    <button
                        className="Divider__title"
                        onClick={this.handleClick}
                        aria-expanded={isExpanded}
                        aria-controls={id}
                        id={dividerId}
                    >
                        <div className="Divider__title-layout">
                            <div className="Divider__title-left">
                                <div className="Divider__title-row" />
                            </div>
                            <div className="Divider__title-text">
                                {typeof heading === 'string' &&
                                    <span>{heading}</span>
                                }
                                {typeof heading === 'function' &&
                                    heading()
                                }
                            </div>
                            <div className="Divider__title-right">
                                <div className="Divider__title-row" />
                                <SVGIcon className={svgClassName} markup={CHEVRON_DOWN__16} />
                            </div>
                        </div>
                    </button>
                </div>
                <CollapseBase
                    aria-labelledby={dividerId}
                    className="Divider__body"
                    id={id}
                    expanded={isExpanded}
                    role="region"
                >
                    {children}
                </CollapseBase>
            </div>
        );
    }
}

export default Divider;
